module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_4.bd29faae.svg";